import React from 'react';

import type { BrowseLinkDef } from '@gumtree/shared/src/types/web-bff';
import { Link, LinkList } from '@gumtree/ui-library';
import slug from '@gumtree/ui-library/src/utils/slug';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';

import { mapLocationToLink } from './browse-links-service';
import { getClinetPageCategories } from '../utils';

const trackTopLocationClick = (
    e: React.MouseEvent,
    item: { href: string; text: string },
    index: number,
    positionOffset: number
) =>
    trackGA4AndNavigate<GA4.BrowseLinksEvent>({
        href: item.href,
        mouseEvent: e,
        payload: {
            event: 'link_click',
            linkDomain: getLinkHostname(item.href),
            linkText: item.text,
            linkType: 'inside',
            linkURL: item.href,
            linkLocation: 'topLocations',
            listLinkDetail: getClinetPageCategories(),
            linkPosition: positionOffset + index + 1,
            linkDetail: {},
        },
    });

export default function TopLocationItem({
    items,
    positionOffset = 0,
    title,
    showTitle,
    omitNativeTitle = false,
    homepageSeo = false,
}: Props) {
    const links = items.map(mapLocationToLink);
    const renderLinks = () => (
        <ul className="link-list">
            {links.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index} className="item">
                    <h3
                        style={{
                            display: 'inline',
                            fontSize: 'inherit',
                            fontWeight: 'inherit',
                            lineHeight: 'inherit',
                            margin: 0,
                            color: 'inherit',
                            letterSpacing: 'inherit',
                        }}
                    >
                        <Link
                            href={item.href}
                            text={item.text}
                            title={omitNativeTitle ? '' : item.text}
                            onClick={(e) =>
                                trackTopLocationClick(e, item, index, positionOffset)
                            }
                        />
                    </h3>
                </li>
            ))}
        </ul>
    );

    return (
        <>
            {showTitle && <h4 {...qaAttribute(`top-location-${slug(title)}`)}>{title}</h4>}
            {homepageSeo ? (
                renderLinks()
            ) : omitNativeTitle ? (
                <ul className="link-list">
                    {links.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index} className="item">
                            <Link
                                href={item.href}
                                text={item.text}
                                title=""
                                onClick={(e) =>
                                    trackTopLocationClick(e, item, index, positionOffset)
                                }
                            />
                        </li>
                    ))}
                </ul>
            ) : (
                <LinkList
                    items={links}
                    onClickItem={(e, item, index) =>
                        trackTopLocationClick(e, item, index, positionOffset)
                    }
                />
            )}
        </>
    );
}

interface Props {
    items: BrowseLinkDef['items'];
    positionOffset?: number;
    showTitle: boolean;
    title: string;
    /** Desktop WHC=C：去掉原生 title 气泡，与 L2 二级类目 hover 一致 */
    omitNativeTitle?: boolean;
    homepageSeo?: boolean;
}
